import { FC } from 'react';
import Modal from '../../modal/Modal';
import { BUTTON_CONSTANTS, MARKETPLACE_CONSTANTS, PAYMENT_CONSTANTS } from '../../../constants/common';
import './stripePayoutReviewModal.scss';

type StripePayoutReviewModalProps = {
  isOpen: boolean;
  onClose: () => void;
};

const StripePayoutReviewModal: FC<StripePayoutReviewModalProps> = ({ isOpen, onClose }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} width={520} ignoreBackdrop>
      <div className="stripe-payout-review-modal">
        <div className="header">
          <h4>{PAYMENT_CONSTANTS.PAYMENT_INFORMATION}</h4>
        </div>
        <div className="body">
          <p>{MARKETPLACE_CONSTANTS.STRIPE_PAYOUT_PENDING_VERIFICATION}</p>
        </div>
        <div className="footer">
          <button type="button" className="button medium green" onClick={onClose}>
            {BUTTON_CONSTANTS.OK}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default StripePayoutReviewModal;
